"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavButton = void 0;
const react_1 = __importDefault(require("react"));
const nav_button_styles_1 = require("./nav-button.styles");
require("./nav-button.types");
const NavButton = ({ label, disabled, isActive, content, onClick, }) => {
    return (react_1.default.createElement(nav_button_styles_1.NavButtonWrapper, null,
        react_1.default.createElement(nav_button_styles_1.NavButtonContent, { onClick: () => {
                onClick && !disabled && onClick();
            }, disabled: disabled, isActive: isActive }, content),
        label && react_1.default.createElement(nav_button_styles_1.NavButtonLabel, null, label)));
};
exports.NavButton = NavButton;
